// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import router from './router'
import axios from 'axios'
import VueGoogleApi from 'vue-google-api'

// import Html2Canvas from 'html2canvas'
// import JsPdf from 'jspdf'

import Tmeka from './Tmeka'
import Top from '@/components/layout/Top'
import Left from '@/components/layout/Left'
import Popup from '@/components/popup/PopupCon.vue'
import {Base64, toCount, numberToComma} from '@/components/js/Utils.js'

Vue.use(Vuex)
const moment = require('moment')
require('moment/locale/es')
Vue.use(require('vue-moment'), {moment})
// Vue.prototype.Html2Canvas = Html2Canvas
// Vue.prototype.JsPdf = new JsPdf()

const store = new Vuex.Store({
  state: {
    login: false,
    loading: true,
    loadingTime: Date.now(),
    left: true,
    leftPageIndex: 0,
    popup: false,
    menuOption: null,
    popupOption: null,
    calendarOption: null,
    inputLibrary: false,
    user: {
      auth: null,
      id: null,
      nic: null,
      profile: null,
      chargePoint: 0,
      revenuePoint: 0,
      fontsize: -1,
      linesize: -1,
      subscribe: [],
      issubscribe: false,
      isalarm: false
    },
    ui: null,
    inspection: null,
    dev: false
  },
  getters: {
    isDev: state => { return state.dev },
    ui: state => { return state.ui },
    inspection: state => { return state.inspection },
    isLogin: state => { return state.login },
    isPageLoading: state => { return state.loading },
    getLoadingTime: state => { return state.loadingTime },
    getPageIndex: state => { return state.leftPageIndex },
    isPopup: state => { return state.popup },
    isLeft: state => { return state.left },
    menu: state => { return state.menuOption },
    popup: state => { return state.popupOption },
    calendar: state => { return state.calendarOption },
    isInputLibrary: state => { return state.inputLibrary },
    auth: state => { return state.user.auth },
    id: state => { return state.user.id },
    nic: state => { return state.user.nic },
    profile: state => { return (state.user.profile !== null) ? state.user.profile : '' },
    chargePoint: state => { return state.user.chargePoint },
    revenuePoint: state => { return state.user.revenuePoint },
    subscribe: state => { return state.user.subscribe },
    issubscribe: state => { return state.user.issubscribe },
    isalarm: state => { return state.user.isalarm },
    fontsize: state => { return state.user.fontsize },
    linesize: state => { return state.user.linesize }
  },
  mutations: {
    login (state, value) { state.login = value },
    loading (state, value) { state.loading = value },
    loadingTime (state) { state.loadingTime = Date.now() },
    dev (state, value) { state.dev = value },
    ui (state, value) { state.ui = value },
    inspection (state, value) { state.inspection = value },
    popup (state, value) { state.popup = value },
    left (state) { state.left = !state.left },
    openMenu (state, value) { state.menuOption = value },
    closeMenu (state) { state.menuOption = null },
    openPopup (state, value) { state.popupOption = value },
    calendar (state, value) { state.calendarOption = value },
    inputLibrary (state, value) { state.inputLibrary = value },
    auth (state, value) { state.user.auth = value },
    userid (state, value) { state.user.id = value },
    nic (state, value) { state.user.nic = value },
    profile (state, value) { state.user.profile = value },
    chargePoint (state, value) { state.user.chargePoint = value },
    revenuePoint (state, value) { state.user.revenuePoint = value },
    subscribe (state, value) { state.user.subscribe = value },
    issubscribe (state, value) { state.user.issubscribe = value },
    isalarm (state, value) { state.user.isalarm = value },
    fontsize (state, value) { state.user.fontsize = value },
    linesize (state, value) { state.user.linesize = value }
  },
  actions: {
    logOut ({commit}, init) {
      console.log('logout', init, sessionStorage.getItem('token'))
      commit('login', false)
      commit('auth', null)
      commit('userid', null)
      commit('nic', null)
      commit('profile', null)
      commit('chargePoint', null)
      commit('revenuePoint', null)
      commit('subscribe', null)
      commit('fontsize', null)
      commit('linesize', null)
      if (!init) {
        sessionStorage.removeItem('token')
      }
    },
    logIn ({commit}, token) {
      console.log('login', token)
      if (token) {
        sessionStorage.setItem('token', token)
        checkPassport()
      }
      // upenbeEdit 때문에 넣은 코드 **
      commit('login', true)
    },
    reLogIn ({commit}) {
      console.log('reLogIn', Vue.prototype.$gapi)
      Vue.prototype.$gapi._libraryLoad('client').then(client => {
        Vue.prototype.$gapi.client = client
        Vue.prototype.$gapi._libraryLoad('auth2').then(auth2 => {
          Vue.prototype.$gapi.auth2 = auth2
          return auth2.init(Vue.prototype.$gapi.config)
        })
      })
    },
    checkLogin ({commit}) {
      console.log('login')
      checkPassport()
    },
    closeMenu ({commit}) {
      commit('closeMenu')
    },
    pushLately ({commit}, id) {
      var li = JSON.parse(sessionStorage.getItem('lately'))
      console.log('pushLately', li)
      if (!li) {
        li = []
      }
      var k = Boolean(li.indexOf(id) === -1)
      if (k) {
        li.push(id)
      } else {
        li.splice(li.indexOf(id), 1)
        li.push(id)
      }
      if (li.length > 30) {
        li.pop()
      }
      sessionStorage.setItem('lately', JSON.stringify(li))
      return k
    },
    removeLately ({commit}, id) {
      if (id === 'all') {
        sessionStorage.removeItem('lately')
      } else {
        var li = JSON.parse(sessionStorage.getItem('lately'))
        li.splice(li.indexOf(id), 1)
        sessionStorage.setItem('lately', JSON.stringify(li))
      }
    },
    isLately ({commit}, id) {
      var li = JSON.parse(sessionStorage.getItem('lately'))
      if (!li) {
        li = []
      }
      return Boolean(li.indexOf(id) === -1)
    },
    subscribe ({commit}) {
      Vue.prototype.$http.post('/api/library/getSubscribeList').then((e) => {
        console.log('getSubscribeList', e)
        if (e.success) {
          commit('subscribe', e.data)
        }
      })
    },
    issubscribe ({commit}) {
      Vue.prototype.$http.post('/api/library/alarmSubscribe').then((e) => {
        console.log('alarmSubscribe', e)
        if (e.success) {
          commit('issubscribe', Boolean(e.data.length))
        }
      })
    },
    isalarm ({commit}) {
      Vue.prototype.$http.post('/api/user/isAlarm').then((e) => {
        console.log('isalarm', e)
        if (e.success) {
          commit('isalarm', Boolean(e.isAlarm))
        }
      })
    }
  }
})

Vue.config.productionTip = false
var axiosObj = axios.create()
Vue.prototype.$http = axiosObj
console.log('add axios interceptors')
axiosObj.interceptors.request.use((req) => {
  // console.log('interceptors request token', sessionStorage.getItem('token'))
  if (sessionStorage.getItem('token')) {
    req.headers['x-access-token'] = sessionStorage.getItem('token')
  }
  return req
}, (err) => {
  console.log('default res err')
  return Promise.reject(err)
})
axiosObj.interceptors.response.use((res) => {
  console.log('interceptors response axios', res)
  return res.data
}, (err) => {
  console.log('default res err', err)
  return Promise.reject(err)
})
axios.interceptors.response.use((res) => {
  // console.log('default res axios', res)
  return res.data
}, (err) => {
  console.log('default res err', err)
  return Promise.reject(err)
})
// console.log(Vue.prototype.$http.interceptors.response)
Vue.prototype.$center = new Vue({
  data: function () {
    return {
      stepList: {}
    }
  },
  methods: {
    dispatch (type, param) {
      this.$emit(type, param)
    },
    addEvent (type, cb) {
      this.$on(type, cb)
    },
    removeEvent (type, cb) {
      this.$off(type, cb)
    },
    addStepEvent (type, step, cb) {
      var ar = this.stepList[type]
      if (!ar) {
        ar = this.stepList[type] = []
      }
      if (!ar[step]) {
        ar[step] = cb
      } else {
        ar.splice(step, 0, cb)
      }
    },
    dispatchStep (type, param) {
      console.log('dispatch type', type)
      if (this.stepList[type]) {
        var temp = Object.keys(this.stepList[type])
        var returnParam = []
        temp.forEach((item) => {
          if (!param.defaultPrevented && this.stepList[type][item]) {
            var dump = this.stepList[type][item](param)
            if (dump) {
              returnParam.push(dump)
            }
          }
        })
        return returnParam
      }
      return []
    },
    removeStepEvent (type, cb) {
      var ar = this.stepList[type]
      if (ar) {
        if (ar.indexOf(cb) !== -1) {
          ar.splice(ar.indexOf(cb), 1)
        }
      }
    },
    time () {
      return Vue.prototype.$http.post('/api/auth/time').then((res) => {
        if (res.success) {
          return res.data
        } else {
          return Date.now()
        }
      })
    }
  }
})

const requireComponent = require.context(
  './components/ui',
  true,
  /[A-Z]\w+\.(vue|js)$/
)
requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  const componentName = upperFirst(
    camelCase(
      fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
    )
  )
  console.log(componentName)
  Vue.component(
    componentName,
    componentConfig.default || componentConfig
  )
})

Vue.component('top', Top)
Vue.component('left', Left)
Vue.component('popup', Popup)

/* eslint-disable no-new */
var data = {
  isDev: false
}
Vue.mixin({
  created () {
    this.$center.addEvent('login', this.loginInit)
  },
  computed: {
    document () { return document },
    isLogin () { return this.$store.getters.isLogin },
    isLeft () { return this.$store.getters.isLeft },
    getPageIndex () { return this.$store.getters.getPageIndex },
    isPopup () { return this.$store.getters.isPopup },
    isInputLibrary () { return this.$store.getters.isInputLibrary },
    fontsize () { return this.$store.getters.fontsize },
    linesize () { return this.$store.getters.linesize },
    getBookClass () { return (this.isLeft) ? 'leftOnBookListContent' : 'leftOffBookListContent' },
    getPostClass () { return (this.isLeft) ? 'leftOnPostListContent' : 'leftOffPostListContent' },
    getBannerClass () { return (this.isLeft) ? 'onBannerBox' : 'bannerBox' }
  },
  methods: {
    toCount (n) {
      return toCount(n)
    },
    numberToComma (n) {
      return numberToComma(n)
    },
    loginInit () {
      console.log('login Init')
      this.$center.removeEvent('login', this.loginInit)
    },
    setPageLoading (value) {
      var minTime = 300
      if (value) {
        this.$store.commit('loadingTime')
        this.$store.commit('loading', value)
      } else {
        if (Date.now() - this.$store.getters.getLoadingTime > minTime) {
          this.$store.commit('loading', value)
        } else {
          setTimeout(this.setPageLoading, minTime - (Date.now() - this.$store.getters.getLoadingTime), value)
        }
      }
    },
    href (link, params) {
      switch (process.env.NODE_ENV) {
        case 'development' :
          console.log(link)
          // this.$router.push('/a')
          if (!params) {
            params = ''
          }
          if (link.indexOf('?') === -1) {
            window.location = link + '?dev=true&' + params
          } else {
            window.location = link + '&dev=true&' + params
          }
          // window.location.href = 'http://www.naver.com'
          console.log(window.location)
          // window.open('http://localhost:3000' + link + '?dev=true&token=' + sessionStorage.getItem('token'))
          break
        default :
          if (params) {
            window.location = link + '?' + params
          } else {
            window.location = link
          }
          break
      }
    },
    compareMy (id) {
      console.log(this.$store.getters.id, id)
      if (id !== null && id !== undefined && this.$store.getters.id !== null && this.$store.getters.id !== undefined) {
        return this.$store.getters.id === id
      }
      return false
    },
    delegate (scope, func) {
      var caller = function (e) {
        func.apply(scope, [e])
      }
      return caller
    },
    alert (message, icon, req, cb) {
      console.log('mixin ualert')
      var param
      if (typeof message === 'string') {
        param = {message: message, icon: icon, require: req, type: 'alert'}
      } else {
        param = message
        param.type = 'alert'
        cb = icon
      }
      this.$store.commit('openPopup', {
        type: 'UiconPopup',
        param: param,
        callback: cb
      })
    },
    confirm (p1, p2) {
      console.log('mixin uconfirm')
      var param = (typeof p1 === 'function') ? '' : p1
      var cb = (typeof p1 === 'function') ? p1 : p2
      param.type = 'confirm'
      this.$store.commit('openPopup', {
        type: 'UiconPopup',
        param: param,
        callback: cb
      })
    },
    openPopup (type, p1, p2) {
      console.log('mixin openPopup')
      var param = (typeof p1 === 'function') ? {} : p1
      var cb = (typeof p1 === 'function') ? p1 : p2
      this.$store.commit('openPopup', {
        type: type,
        param: param,
        callback: cb
      })
    },
    openMenu (type, target, param, cb) {
      console.log('openMenu')
      var rect = target.getBoundingClientRect()
      this.$store.commit('openMenu', {
        type: type,
        x: rect.left,
        y: rect.top + rect.height,
        h: rect.height,
        my: param.my,
        visible: param.visible,
        delete: param.delete,
        mainopen: param.mainopen,
        param: param.param,
        callback: cb
      })
    },
    openCalendar (target, p1, p2) {
      var rect = target.getBoundingClientRect()
      var date = (typeof p1 === 'function') ? new Date() : p1
      var cb = (typeof p1 === 'function') ? p1 : p2
      console.log(rect)
      this.$store.commit('calendar', {
        x: rect.left,
        y: rect.top + rect.height,
        h: rect.height,
        date: date,
        callback: cb
      })
    },
    openInputLibrary (title, value, p1, p2) {
      var ob = (typeof p1 === 'function') ? {} : p1
      var cb = (typeof p1 === 'function') ? p1 : p2
      console.log(p1)
      ob.title = title
      ob.value = value
      ob.cb = cb
      this.$center.dispatch('libraryInput-open', ob)
      this.$center.addEvent('libraryInput-complete', (input) => {
        cb(input)
        this.$center.removeEvent('libraryInput-complete')
      })
    },
    isTarget (p, t) {
      p = p.path
      if (p) {
        for (var i = 0; i < p.length; i++) {
          if (p[i] === t) {
            return true
          }
        }
      }
      return false
    },
    newEvent (type, target, result, value) {
      return {type: type, target: target, result: result, param: value}
    }
  }
})

function loginTokenTrans (e) {
  if (!e) { e = window.event }
  if (!e.newValue) return
  console.log('loginToken_trans', e.key)
  switch (e.key) {
    case 'getLoginTmeka':
      if (sessionStorage.length) {
        localStorage.setItem('loginTmeka', JSON.stringify(sessionStorage))
        localStorage.removeItem('loginTmeka')
      }
      break
    case 'loginTmeka':
      if (!sessionStorage.length) {
        var data = JSON.parse(event.newValue)
        for (var key in data) {
          sessionStorage.setItem(key, data[key])
        }
      }
      break
  }
}

if (window.addEventListener) {
  window.addEventListener('storage', loginTokenTrans, false)
} else {
  window.attachEvent('onstorage', loginTokenTrans)
}

function checkPassport () {
  if (sessionStorage.getItem('token')) {
    if (store.getters.isLogin === false) {
      Vue.prototype.$http.post('/api/auth/passport').then((res) => {
        console.log('passport', res)
        if (res.success) {
          store.commit('auth', res.auth)
          switch (res.auth) {
            case 'drive' :
              console.log(window.location)
              if (window.location.pathname === '/upenbeedit') {
                store.dispatch('logIn', false)
                Base64._keyStr = res.key
                console.log('Base64._keyStr', Base64._keyStr)
                Vue.use(VueGoogleApi, {
                  apiKey: 'UpenbeEdit',
                  clientId: res.clientID,
                  scope: 'https://www.googleapis.com/auth/drive',
                  // discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/drive/v3/rest']
                  discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/driveactivity/v2/rest']
                })
                store.dispatch('reLogIn')
              } else {
                sessionStorage.removeItem('token')
              }
              break
            case 'admin':
              console.log(window.location.pathname.indexOf('admin'))
              if (window.location.pathname.indexOf('admin') !== -1 || window.location.pathname.indexOf('popup') !== -1) {
                store.commit('login', true)
                console.log('check passport', Vue.prototype.$center)
                Vue.prototype.$center.dispatch('login')
              } else {
                sessionStorage.removeItem('token')
                store.commit('login', false)
              }
              // if (window.location.pathname === '/upenbeedit') {
              //   store.dispatch('logIn', false)
              //   Base64._keyStr = res.key
              //   console.log('Base64._keyStr', Base64._keyStr)
              //   Vue.use(VueGoogleApi, {
              //     apiKey: 'UpenbeEdit',
              //     clientId: res.clientID,
              //     scope: 'https://www.googleapis.com/auth/drive',
              //     // discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/drive/v3/rest']
              //     discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/driveactivity/v2/rest']
              //   })
              //   store.dispatch('reLogIn')
              // } else {
              //   sessionStorage.removeItem('token')
              // }
              break
            default :
              if (router.history.current.name !== 'upenbeedit') {
                console.log('change admin login', router.history.current.matched)
                if (router.history.current.matched.length) {
                  switch (router.history.current.matched[0].path) {
                    case '/admin':
                      console.log('change admin login')
                      store.dispatch('logIn', false)
                      sessionStorage.removeItem('token')
                      break
                    default :
                      store.commit('login', true)
                      store.commit('userid', res.id)
                      store.dispatch('subscribe')
                      break
                  }
                } else {
                  store.commit('login', true)
                  store.commit('userid', res.id)
                  store.dispatch('subscribe')
                }
              } else {
                store.commit('login', false)
              }
              break
          }
        } else {
          console.log('passport token remove')
          sessionStorage.removeItem('token')
        }
      })
    }
  } else {
    store.commit('login', false)
    Vue.prototype.$center.dispatch('login')
  }
}
checkPassport()
document.cookie = 'crossCooke=foo; SameSite=None; Secure'
new Vue({
  el: '#tmeka',
  data: data,
  store,
  router,
  watch: {
    '$route': (e) => {
      console.log('route', e.name, store.getters.isLogin)
      switch (e.name) {
        case 'upenbeedit' :
          if (store.getters.id !== null && store.getters.isLogin) {
            store.commit('login', false)
          }
          break
        default :
          if (e.matched.length) {
            switch (e.matched[0].path) {
              case '/admin':
                if (store.getters.id !== null && store.getters.isLogin) {
                  store.commit('login', false)
                }
                break
              case '/user':
                if (!store.getters.isLogin) {
                  store.commit('openPopup', {
                    type: 'UiconPopup',
                    param: {message: '접근할수 없는 공간입니다.', icon: '107', require: true, type: 'alert'},
                    callback: (e) => {
                      // console.log(this.category)
                      router.push({name: 'main'})
                    }
                  })
                } else if (store.getters.id === null && store.getters.isLogin) {
                  store.commit('login', false)
                }
                if (store.getters.inspection.is) {
                  router.push({name: 'main'})
                }
                break
              default :
                if (store.getters.id === null && store.getters.isLogin) {
                  store.commit('login', false)
                }
                if (store.getters.inspection.is) {
                  router.push({name: 'main'})
                }
                break
            }
          } else {
            if (store.getters.id === null && store.getters.isLogin) {
              store.commit('login', false)
            }
          }
          break
      }
    }
  },
  computed: {
    isCon () {
      console.log('main', this.$route.matched.length, this.$route.matched)
      if (this.$route.name !== 'upenbeedit') {
        if (this.$route.matched.length) {
          switch (this.$route.matched[0].path) {
            case '/admin':
            case '/popup':
              return false
            default:
              return true
          }
        } else {
          return true
        }
      }
      return false
    }
  },
  methods: {
    changeType (e) {
      // console.log(e)
      switch (this.$route.name) {
        case 'edit' :
        case 'postedit' :
        case 'bookedit' :
        case 'categoryedit' :
        case 'workedit' :
          break
        case 'upenbeedit' :
          break
        default :
          if (this.$route.matched.length) {
            switch (this.$route.matched[0].path) {
              case '/admin':
                break
              default :
                e.preventDefault()
                break
            }
          } else {
            e.preventDefault()
          }
          break
      }
    },
    loginInit () {
      console.log('loginInit')
    }
  },
  components: { Tmeka },
  template: '<Tmeka v-if="isCon" @dragstart.native="changeType" @selectstart.native="changeType"/><div v-else ><router-view/></div>',
  created () {
    Vue.prototype.$http.post('/api/inspection').then((e) => {
      console.log('inspection', e)
      if (e.success) {
        store.commit('inspection', e.data)
      }
    })
    console.log('main create', sessionStorage.getItem('token'), store.getters.isLogin)
    if (!sessionStorage.length) {
      localStorage.setItem('getLoginTmeka', 'login')
    }
    localStorage.removeItem('getLoginTmeka', 'login')
    this.$center.addEvent('login', this.loginInit)
    if (sessionStorage.getItem('token') && !store.getters.isLogin) {
      checkPassport()
    } else {
      console.log('not login', this.$route)
    }
    let re = document.createElement('script')
    re.setAttribute('src', 'https://code.jquery.com/jquery-3.3.1.min.js')
    document.head.appendChild(re)
    re = document.createElement('script')
    re.setAttribute('src', 'https://cdn.iamport.kr/js/iamport.payment-1.1.8.js')
    document.head.appendChild(re)
    var checkIMP = () => {
      console.log('window.IMP', window.IMP)
      if (window.IMP !== null) {
        var IMP = window.IMP
        IMP.init('imp72021169')
        console.log('IMP setting')
      } else {
        setTimeout(checkIMP, 1000)
      }
    }
    setTimeout(checkIMP, 1000)
  }
})



// WEBPACK FOOTER //
// ./src/main.js